import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'PROVEN',
  logo: { name: 'PROVEN', src: '/logo/provencard.png' },
  portrait: { src: '/photo/portrait-johann-heaven.png', alt: 'Johann Heaven' },
  quote: [
    'Working with Digitopia has been a transformative experience for PROVEN. The Digital '
    + 'Maturity Index provided the clarity and structure we needed to assess our '
    + 'capabilities, while the interactive sessions delivered valuable, actionable insights. '
    + 'Benchmarking against industry peers gave us clear direction, ensuring smarter '
    + 'investments and stronger alignment across leadership. This initiative has set a solid '
    + 'foundation for our digital transformation, and we’re excited to build on this '
    + 'momentum.',
  ],
  attribution: 'Johann Heaven, CEO, PROVEN',
  story: 'proven',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 12
